
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  display:block;
}

:host([full-bleed]) {
  max-width: 100%;
}

:host([container-align]), :host([container-align='center']) {
  margin-left: auto;
  margin-right: auto;
}

:host([container-align='left']) {
  margin-left: auto;
  margin-right: auto;
  margin-left: 0px;
}

:host([container-align='right']) {
  margin-left: auto;
  margin-right: auto;
  margin-right: 0px;
}

:host([row-background-color='transparent']) {
  border-radius: 0.5rem;
  background-color: var(--neutral-transparent);
  padding: 2rem;
}

:host([row-background-color='white']) {
  border-radius: 0.5rem;
  background-color: var(--neutral-white);
  padding: 2rem;
}

:host([row-background-color='gray']) {
  border-radius: 0.5rem;
  background-color: var(--gray-professional-lighten-4);
  padding: 2rem;
}

:host([row-background-color='black']) {
  border-radius: 0.5rem;
  background-color: var(--neutral-black);
  padding: 2rem;
}

:host([row-background-color='idblab-blue']) {
  border-radius: 0.5rem;
  background-color: var(--idblab-blue-main);
  padding: 2rem;
}

:host([row-background-color='idblab-dark-blue']) {
  border-radius: 0.5rem;
  background-color: var(--idblab-blue-darken-2);
  padding: 2rem;
}

:host([row-background-color='idblab-darkest-blue']) {
  border-radius: 0.5rem;
  background-color: var(--idblab-blue-darken-1);
  padding: 2rem;
}

:host([row-background-color='idblab-light-green']) {
  border-radius: 0.5rem;
  background-color: var(--idblab-green-main);
  padding: 2rem;
}

:host([row-background-color='idblab-green']) {
  border-radius: 0.5rem;
  background-color: var(--idblab-green-darken-1);
  padding: 2rem;
}

:host([row-background-color='idblab-light-yellow']) {
  border-radius: 0.5rem;
  background-color: var(--idblab-yellow-lighten-2);
  padding: 2rem;
}

:host([row-background-color='idblab-yellow']) {
  border-radius: 0.5rem;
  background-color: var(--idblab-yellow-main);
  padding: 2rem;
}

:host([row-background-color='idblab-purple']) {
  border-radius: 0.5rem;
  background-color: var(--idblab-purple-main);
  padding: 2rem;
}

:host([row-background-color='idblab-light-magenta']) {
  border-radius: 0.5rem;
  background-color: var(--idblab-magenta-lighten-2);
  padding: 2rem;
}

:host([row-background-color='idblab-magenta']) {
  border-radius: 0.5rem;
  background-color: var(--idblab-magenta-main);
  padding: 2rem;
}

:host([row-background-color='idblab-magenta'])slot[*|name='grid-module-']::slotted(*), :host([row-background-color='idblab-yellow'])slot[*|name='grid-module-']::slotted(*), :host([row-background-color='idblab-purple'])slot[*|name='grid-module-']::slotted(*), :host([row-background-color='idblab-green'])slot[*|name='grid-module-']::slotted(*), :host([row-background-color='idblab-darkest-blue'])slot[*|name='grid-module-']::slotted(*), :host([row-background-color='idblab-dark-blue'])slot[*|name='grid-module-']::slotted(*), :host([row-background-color='idblab-blue'])slot[*|name='grid-module-']::slotted(*), :host([row-background-color='black'])slot[*|name='grid-module-']::slotted(*){
    color:white !important;
  }
`;